module.exports = "<i ng-show=\"$ctrl.status === 'success'\" class=\"material-icons success\">done</i>\n<i ng-show=\"$ctrl.status === 'error'\" class=\"material-icons error\">close</i>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpStatusIcon/adpStatusIcon.html
// module id = 693
// module chunks = 0